import React from 'react';

const Select = ({ className, size }) => {
    return (
        <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 25.5205L20.2454 28.8524C21.0161 29.6436 22.2823 29.6603 23.0736 28.8895L31.4154 20.7642" stroke="#FFC52F" strokeWidth="2" strokeLinecap="round" />
            <rect x="0.5" y="0.5" width="48" height="48" rx="11.5" stroke="#FFC52F" />
        </svg>
    )
}

export default Select;